import { createContext, useContext } from 'react';
import { useReducedMotion, type MotionProps } from 'motion/react';
import { DURATION, EASE_OUT } from '../motion';

/** Список уже показан (AnimatedList): строки, смонтированные после первого показа, проявляются. Вне списка — проявляются всегда. */
export const ListAppearContext = createContext(true);

/**
 * Появление и уход строки списка (приём mrbooker): новая строка проявляется, удалённая гаснет (при AnimatePresence).
 * Переезд на новое место — AnimatedList по data-flip-id. Только прозрачность: высота блока и замер 5 строк
 * (по offsetTop, см. ExpandableBlock) не плывут. «Уменьшить движение» — сразу.
 */
export function useListItemMotion(): Pick<MotionProps, 'initial' | 'animate' | 'exit' | 'transition'> {
  const reduced = useReducedMotion();
  const appeared = useContext(ListAppearContext);
  if (reduced) return { initial: false, animate: { opacity: 1 }, transition: { duration: 0 } };
  return {
    initial: appeared ? { opacity: 0 } : false,
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: DURATION.fast, ease: EASE_OUT },
  };
}
